
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[uid]/[verticalid]/[clusterid]",
      function () {
        return require("private-next-pages/[uid]/[verticalid]/[clusterid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[uid]/[verticalid]/[clusterid]"])
      });
    }
  